import { useScreen0Language } from "@/features/language";
import { formatTemplate, getTranslations } from "@/i18n";
import { triggerSelectionChangeHaptic } from "../../lib/native/haptics";

type DailyAverageToggleProps = {
  active: boolean;
  disabled: boolean;
  onToggle: () => void;
};

export function DailyAverageToggle({ active, disabled, onToggle }: DailyAverageToggleProps) {
  const { languageCode } = useScreen0Language();
  const t = getTranslations(languageCode);

  return (
    <div className="pointer-events-none absolute top-2 right-2 z-10">
      <button
        type="button"
        className={`today-daily-average-toggle liquid-glass-control pointer-events-auto${
          active ? " today-daily-average-toggle-active" : ""
        }`}
        aria-pressed={active}
        aria-label={formatTemplate(t.today.dailyAverageToggleAria, {
          state: active ? t.today.dailyAverageOn : t.today.dailyAverageOff,
        })}
        disabled={disabled}
        onClick={() => {
          triggerSelectionChangeHaptic();
          onToggle();
        }}
      >
        {t.today.dailyAverage}
      </button>
    </div>
  );
}
